// extracted by mini-css-extract-plugin
export default {"section":"MapSection_section__I2OQQ","subsectionWrapper":"MapSection_subsectionWrapper__Yt+8P"};